var _defs, _path, _mask, _g, _path2, _path3, _mask2, _g2, _g3, _g4, _g5, _path4, _g6, _g7, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.94000000000001,
    height: 86,
    viewBox: "0 0 103.94000000000001 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_0",
    x1: "79.8436889%",
    y1: "84.7046849%",
    x2: "25.2178103%",
    y2: "12.72747350000001%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8357FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B982FF",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_0",
    transform: "translate(0 -4.629293581467319e-15) rotate(0 38.73488938289254 43)",
    d: "M0,23.64L0,62.36C0,63.88 0.82,65.27 2.14,66.02L36.66,85.46C37.95,86.18 39.52,86.18 40.81,85.46L75.33,66.02C76.65,65.27 77.47,63.88 77.47,62.36L77.47,23.64C77.47,22.12 76.65,20.73 75.33,19.98L40.81,0.54C39.52,-0.18 37.95,-0.18 36.66,0.54L2.14,19.98C0.82,20.73 0,22.12 0,23.64Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter_11",
    x: 0,
    y: 0,
    width: 50.359349680649416,
    height: 31.77752783530622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_1",
    x1: "73.8665507%",
    y1: "88.8600417%",
    x2: "25.272059499999997%",
    y2: "13.002353300000003%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D795FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282501697,
    stopColor: "#FC74AB",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6100158480000001,
    stopColor: "#B452FD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925DFF",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_2",
    x1: "50%",
    y1: "120.384768%",
    x2: "51%",
    y2: "0%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E12072",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59154064,
    stopColor: "#7A27D6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A2FC8",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    transform: "translate(0 0) rotate(0 31.57735545413258 35.46713772165805)",
    d: "M0,52.27C0,52.88 0.33,53.43 0.85,53.73L30.96,70.77C31.34,70.99 31.81,70.99 32.2,70.77L62.3,53.85C62.83,53.55 63.15,52.99 63.15,52.38L63.15,18.51C63.15,17.91 62.83,17.35 62.3,17.05L32.41,0.22C31.89,-0.07 31.26,-0.07 30.75,0.22L0.86,17.05C0.33,17.35 0,17.91 0,18.51L0,52.27Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_3",
    x1: "8.745572930000002%",
    y1: "57.1980705%",
    x2: "93.3789277%",
    y2: "57.1980705%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4117DD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539962661,
    stopColor: "#733AFB",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF44E7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_4",
    x1: "91.25442707%",
    y1: "57.1980705%",
    x2: "6.621072299999997%",
    y2: "57.1980705%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4117DD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539962661,
    stopColor: "#733AFB",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF44E7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_27",
    x: 0,
    y: 0,
    width: 63.154710950368276,
    height: 66.6143946414776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_5",
    x1: "32.72196770000001%",
    y1: "10.994075699999998%",
    x2: "71.15473080000001%",
    y2: "49.99999999999999%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FA75AE",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_6",
    x1: "50%",
    y1: "29.589460999999993%",
    x2: "58.3297352%",
    y2: "51.9253572%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEC8A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA318E",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_7",
    x1: "40.1692165%",
    y1: "2.068451939999999%",
    x2: "41.476947%",
    y2: "64.2636605%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F9A367",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D433C4",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    transform: "translate(0 1.0926736858529686) rotate(0 8.90263690113304 16.52008303654909)",
    d: "M4.05,22.82L4.22,23.09C4.28,23.18 4.34,23.28 4.4,23.37L4.59,23.65C4.65,23.75 4.72,23.85 4.79,23.95L5,24.25L5.23,24.56L5.46,24.87L5.71,25.19L5.96,25.53L6.23,25.86L6.51,26.21C6.56,26.27 6.61,26.33 6.65,26.39L6.95,26.75L7.26,27.11L7.57,27.48L7.9,27.87L8.24,28.26L8.59,28.65L8.95,29.06L9.33,29.47L9.71,29.89L10.11,30.31L10.51,30.75L10.93,31.19L11.57,31.87L12.25,32.57L12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C10.79,10.33 10,9.11 9.17,7.71L8.88,7.2L8.59,6.68C8.49,6.51 8.39,6.33 8.29,6.15L7.99,5.6C7.79,5.23 7.59,4.84 7.39,4.45L7.09,3.85C6.98,3.65 6.88,3.45 6.78,3.24L6.47,2.61L6.16,1.97C6,1.64 5.84,1.31 5.69,0.97L5.64,0.87C5.52,0.65 5.35,0.46 5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7L2.66,0.89C1.04,3.23 0.15,6.11 0.01,9.55C-0.03,10.3 0.06,11.28 0.25,12.42L0.32,12.81C0.33,12.87 0.35,12.94 0.36,13L0.44,13.4C0.5,13.67 0.56,13.95 0.63,14.23L0.73,14.66C0.81,14.94 0.89,15.23 0.97,15.53L1.1,15.98C1.71,17.99 2.57,20.16 3.68,22.18L3.82,22.43C3.89,22.56 3.97,22.69 4.05,22.82Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_8",
    x1: "35.3973703%",
    y1: "5.216632150000001%",
    x2: "24.6946432%",
    y2: "55.6861926%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FED391",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7C5F",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_9",
    x1: "39.1069435%",
    y1: "4.813201490000002%",
    x2: "43.5085671%",
    y2: "62.42288120000001%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFBB6C",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B59",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    transform: "translate(0 -3.552713678800501e-15) rotate(0 8.90263690113304 16.52008303654909)",
    d: "M4.59,23.65C4.65,23.75 4.72,23.85 4.79,23.95L5,24.25L5.23,24.56L5.46,24.87L5.71,25.19L5.96,25.53L6.23,25.86L6.51,26.21C6.56,26.27 6.61,26.33 6.65,26.39L6.95,26.75L7.26,27.11L7.57,27.48L7.9,27.87L8.24,28.26L8.59,28.65L8.95,29.06L9.33,29.47L9.71,29.89L10.11,30.31L10.51,30.75L10.93,31.19L11.57,31.87L12.25,32.57L12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C10.79,10.33 10,9.11 9.17,7.71L8.88,7.2L8.59,6.68C8.49,6.51 8.39,6.33 8.29,6.15L7.99,5.6C7.79,5.23 7.59,4.84 7.39,4.45L7.09,3.85C6.98,3.65 6.88,3.45 6.78,3.24L6.47,2.61L6.16,1.97C6,1.64 5.84,1.31 5.69,0.97L5.64,0.87C5.52,0.65 5.35,0.46 5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7L2.66,0.89C1.04,3.23 0.15,6.11 0.01,9.55C-0.03,10.3 0.06,11.28 0.25,12.42L0.32,12.81C0.33,12.87 0.35,12.94 0.36,13L0.44,13.4C0.5,13.67 0.56,13.95 0.63,14.23L0.73,14.66C0.81,14.94 0.89,15.23 0.97,15.53L1.1,15.98C1.71,17.99 2.57,20.16 3.68,22.18L3.82,22.43C3.89,22.56 3.97,22.69 4.05,22.82L4.22,23.09C4.28,23.18 4.34,23.28 4.4,23.37L4.59,23.65Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_10",
    x1: "36.9577939%",
    y1: "5.338484450000003%",
    x2: "28.755911900000005%",
    y2: "47.92836410000001%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF4C1",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB066",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_11",
    x1: "50%",
    y1: "0%",
    x2: "52.43252420000001%",
    y2: "76.0932585%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEDA7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    transform: "translate(0 0) rotate(0 8.90263690114514 16.52008296527144)",
    d: "M5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7C1.08,3.07 0.16,6.01 0.01,9.55C-0.1,12.13 1.14,17.54 3.68,22.18C5.03,24.65 8.04,28.27 12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C9.75,8.94 7.79,5.48 5.69,0.97C5.57,0.71 5.38,0.48 5.14,0.32Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_12",
    x1: "43.2876087%",
    y1: "1.4210854715202004e-12%",
    x2: "32.6221683%",
    y2: "52.3884364%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF9DD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE08A",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_13",
    x1: "42.3657072%",
    y1: "7.5801073%",
    x2: "50%",
    y2: "67.84237400000002%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF2B5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB50",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    transform: "translate(0 0) rotate(0 8.676373802358922 16.485915242855622)",
    d: "M8.44,7.16L8.15,6.64C7.81,6.03 7.46,5.39 7.11,4.72L6.81,4.13L6.5,3.53L6.2,2.91C6.1,2.7 5.99,2.49 5.89,2.28L5.58,1.63C5.47,1.41 5.37,1.19 5.27,0.97L5.22,0.88C5.08,0.63 4.89,0.42 4.65,0.27C3.87,-0.23 2.83,-0.01 2.32,0.77L2.2,0.96C0.88,3.1 0.15,5.8 0.01,9.07C-0.04,10.12 0.14,11.62 0.53,13.34L0.63,13.76C0.7,14.04 0.77,14.33 0.85,14.62L0.97,15.06C1.59,17.2 2.49,19.54 3.68,21.71C3.7,21.75 3.73,21.79 3.75,21.84L3.9,22.1C3.92,22.14 3.95,22.18 3.98,22.23L4.14,22.5L4.31,22.78C4.34,22.83 4.37,22.88 4.4,22.93L4.59,23.22C4.62,23.27 4.66,23.32 4.69,23.37L4.9,23.68L5.11,24L5.34,24.33C5.38,24.38 5.41,24.44 5.45,24.49L5.69,24.83L5.95,25.18L6.21,25.54L6.48,25.91L6.76,26.28L7.06,26.66L7.36,27.06L7.84,27.66L8.33,28.29L8.86,28.93L9.22,29.38L9.78,30.06L10.16,30.52L10.56,30.99L11.18,31.72L11.6,32.21L12.25,32.97L17.35,18.34C15.3,16.45 13.22,14.1 11.11,11.28C10.75,10.8 10.38,10.28 10.01,9.72L9.73,9.29C9.64,9.14 9.54,8.99 9.45,8.84L9.16,8.38C8.93,7.99 8.69,7.58 8.44,7.16Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_14",
    x1: "42.2339046%",
    y1: "9.908074720000002%",
    x2: "45.5391855%",
    y2: "58.1711712%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFAE3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA81",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_15",
    x1: "84.1056818%",
    y1: "2.068451939999999%",
    x2: "85.1056818%",
    y2: "58.4988527%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F9A367",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D733BC",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    transform: "translate(-3.552713678800501e-15 1.1386293168134571) rotate(0 8.90263690113304 16.52008303654909)",
    d: "M13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.43,0.48 12.24,0.71 12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_16",
    x1: "64.60262970000001%",
    y1: "5.216632150000001%",
    x2: "75.3053568%",
    y2: "55.6861926%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FED391",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7C5F",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_17",
    x1: "60.8930565%",
    y1: "4.813201490000002%",
    x2: "56.49143290000001%",
    y2: "62.42288120000001%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFBB6C",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8059",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    transform: "translate(0 0) rotate(0 8.90263690113304 16.52008303654909)",
    d: "M13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.46,0.46 12.29,0.65 12.17,0.87L12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_18",
    x1: "63.0422061%",
    y1: "5.338484450000003%",
    x2: "71.2440881%",
    y2: "47.92836410000001%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF4C1",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB066",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_19",
    x1: "50%",
    y1: "0%",
    x2: "47.3637347%",
    y2: "76.0932585%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFEDA7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB46",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_8",
    transform: "translate(0 0) rotate(0 8.90263690113304 16.52008303654909)",
    d: "M6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.46,0.46 12.29,0.65 12.17,0.87L12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_20",
    x1: "56.7123913%",
    y1: "1.4210854715202004e-12%",
    x2: "67.3778317%",
    y2: "52.3884364%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF9DD",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE08A",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_21",
    x1: "57.6342928%",
    y1: "7.5801073%",
    x2: "50%",
    y2: "67.84237400000002%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF2B5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB50",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path_9",
    transform: "translate(0 0) rotate(0 8.676373802358922 16.485915242855622)",
    d: "M13.6,21.84C13.63,21.79 13.65,21.75 13.67,21.71C14.86,19.54 15.77,17.2 16.38,15.06L16.5,14.62C16.58,14.33 16.66,14.04 16.72,13.76L16.82,13.34C17.21,11.62 17.39,10.12 17.35,9.07C17.21,5.8 16.48,3.1 15.15,0.96L15.03,0.77C14.52,-0.01 13.48,-0.23 12.7,0.27C12.43,0.44 12.22,0.68 12.09,0.97C11.98,1.19 11.88,1.41 11.77,1.63L11.46,2.28C11.36,2.49 11.26,2.7 11.15,2.91L10.85,3.53L10.54,4.13L10.24,4.72C9.89,5.39 9.54,6.03 9.2,6.64L8.91,7.16C8.67,7.58 8.43,7.99 8.19,8.38L7.9,8.84C7.81,8.99 7.72,9.14 7.62,9.29L7.34,9.72C6.97,10.28 6.6,10.8 6.24,11.28C4.13,14.1 2.05,16.45 0,18.34L5.1,32.97L5.75,32.21L6.18,31.72L6.79,30.99L7.19,30.52L7.58,30.06L8.14,29.38L8.5,28.93L9.02,28.29L9.52,27.66L9.99,27.06L10.3,26.66L10.59,26.28L10.87,25.91L11.14,25.54L11.41,25.18L11.66,24.83L11.9,24.49C11.94,24.44 11.98,24.38 12.02,24.33L12.24,24L12.46,23.68L12.66,23.37C12.7,23.32 12.73,23.27 12.76,23.22L12.95,22.93C12.98,22.88 13.01,22.83 13.04,22.78L13.21,22.5L13.38,22.23C13.4,22.18 13.43,22.14 13.46,22.1L13.6,21.84Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_22",
    x1: "57.7660954%",
    y1: "9.908074720000002%",
    x2: "54.4608145%",
    y2: "58.1711712%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFAE3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA81",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_23",
    x1: "12.762842999999997%",
    y1: "15.148890900000001%",
    x2: "89.58061329999998%",
    y2: "82.2768076%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFDAA7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556927279,
    stopColor: "#F93B2E",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D11AC1",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_24",
    x1: "14.8620937%",
    y1: "16.601209%",
    x2: "89.5806133%",
    y2: "82.2768076%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6534",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEB8E",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_124",
    x: -2,
    y: -2,
    width: 44.84004641457149,
    height: 44.6874516766627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8980392156862745 0 0 0 0 0.10980392156862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_Shadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_128",
    x: -3.0000000000000178,
    y: -3,
    width: 40.94560672587045,
    height: 40.81503597075262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7843137254901961 0 0 0 0 0.1450980392156863 0 0 0 0 0.4470588235294118 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_Shadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_Shadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_25",
    x1: "20.692219199999997%",
    y1: "15.545564700000003%",
    x2: "94.5462659%",
    y2: "72.8265503%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF8B33",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5889359550000001,
    stopColor: "#F63174",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE33D1",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_26",
    x1: "16.334237999999996%",
    y1: "62.2416714%",
    x2: "88.62679179999999%",
    y2: "25.3095986%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9E67E9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2B2FF",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_27",
    x1: "11.721257099999999%",
    y1: "61.935367299999996%",
    x2: "92.75377729999998%",
    y2: "50%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C07DFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E921C4",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_140",
    x: -1,
    y: -1.0000000000000018,
    width: 11.26027880581096,
    height: 11.231264614812291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843137254902 0 0 0 0 0.37254901960784315 0 0 0 0 0.8784313725490196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_Shadow"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0 51.970000000000006 43)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(8.491689515006458 0)  rotate(0 38.73488938289254 43)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    fillRule: "evenodd",
    fill: "url(#linear_0)",
    transform: "translate(0 0)  rotate(0 38.73488938289254 43)",
    opacity: 1,
    d: "M0,23.64L0,62.36C0,63.88 0.82,65.27 2.14,66.02L36.66,85.46C37.95,86.18 39.52,86.18 40.81,85.46L75.33,66.02C76.65,65.27 77.47,63.88 77.47,62.36L77.47,23.64C77.47,22.12 76.65,20.73 75.33,19.98L40.81,0.54C39.52,-0.18 37.95,-0.18 36.66,0.54L2.14,19.98C0.82,20.73 0,22.12 0,23.64Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 4.629293581467319e-15)  rotate(0 38.73488938289254 43)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84 1",
    filter: "url(#filter_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 1",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(-8.957480641589058 -14.867641597163836)  rotate(0 34.137155481913766 30.756405514816944)",
    opacity: 0.5,
    d: "M16.85,61.51L68.27,21.48L51.43,0L0,40.03L16.85,61.51Z "
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 5.747683677399846)  rotate(0 51.970000000000006 40.03708959942948)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8499\\u7248",
    fillRule: "evenodd",
    fill: "url(#linear_1)",
    transform: "translate(13.54406643313906 0)  rotate(0 33.682512485811515 37.4346892101691)",
    opacity: 1,
    d: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path",
    fillRule: "evenodd",
    fill: "url(#linear_2)",
    transform: "translate(15.649223464818002 1.847827484322579)  rotate(0 31.57735545413258 35.46713772165805)",
    opacity: 1,
    d: "M32.2,70.77L62.3,53.85C62.83,53.55 63.15,52.99 63.15,52.38L63.15,18.51C63.15,17.91 62.83,17.35 62.3,17.05L32.41,0.22C31.89,-0.07 31.26,-0.07 30.75,0.22L0.86,17.05C0.33,17.35 0,17.91 0,18.51L0,52.27C0,52.88 0.33,53.43 0.85,53.73L30.96,70.77C31.34,70.99 31.81,70.99 32.2,70.77Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(15.649223464818002 1.847827484322579)  rotate(0 31.57735545413258 35.46713772165805)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    fill: "url(#linear_3)",
    transform: "translate(-5.89443967185977 29.11261467366016)  rotate(0 37.05076372807719 7.130790562952407)",
    opacity: 0.400000006,
    d: "M0,14.26L37.31,8.83L74.1,14.26L74.1,0L37.29,5.43L0,0L0,14.26Z "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62",
    fillRule: "evenodd",
    fill: "url(#linear_4)",
    transform: "translate(-6.082096774275014 28.58466742200015)  rotate(37.99999999999999 37.89282655759003 7.130790500033669)",
    opacity: 0.400000006,
    d: "M37.65,5.43L0,0L0,14.26L37.63,8.83L75.79,14.26L75.79,0L37.65,5.43Z "
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u692D\\u5706\\u5F62",
    filter: "url(#filter_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#4D26D7"
    },
    transform: "translate(11.367847971066292 13.173200614761381)  rotate(0 20.20950750411785 20.13399670597742)",
    opacity: 0.800000012,
    d: "M20.21,0C9.05,0 0,9.01 0,20.13C0,31.25 9.05,40.27 20.21,40.27C31.37,40.27 40.42,31.25 40.42,20.13C40.42,9.01 31.37,0 20.21,0Z "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    fill: "url(#linear_5)",
    transform: "translate(35.366638090103066 62.669275976126656)  rotate(0 4.8418611728615675 4.8237700441404225)",
    opacity: 0.300000012,
    d: "M4.84,0C2.17,0 0,2.16 0,4.82C0,7.49 2.17,9.65 4.84,9.65C7.52,9.65 9.68,7.49 9.68,4.82C9.68,2.16 7.52,0 4.84,0Z "
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "light",
    fillRule: "evenodd",
    fill: "url(#linear_6)",
    transform: "translate(22.105017865159315 9.0080398200795)  rotate(5 23.864857818266508 16.93420824248715)",
    opacity: 0.5,
    d: "M25.84,33.87L28.45,33.57L47.73,0L0,3.32L25.84,33.87Z "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 6.537480838187107)  rotate(0 27.78908769671412 36.768349180335925)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(15.093195360114006 32.90324277019408)  rotate(-80 18.511835860281483 19.070145267984138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-15",
    fillRule: "evenodd",
    fill: "url(#linear_7)",
    transform: "translate(19.218397918296883 7.105427357601002e-15)  rotate(0 8.90263690113304 16.52008303654909)",
    opacity: 1,
    d: "M7.9,27.87L8.24,28.26L8.59,28.65L8.95,29.06L9.33,29.47L9.71,29.89L10.11,30.31L10.51,30.75L10.93,31.19L11.57,31.87L12.25,32.57L12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C10.79,10.33 10,9.11 9.17,7.71L8.88,7.2L8.59,6.68C8.49,6.51 8.39,6.33 8.29,6.15L7.99,5.6C7.79,5.23 7.59,4.84 7.39,4.45L7.09,3.85C6.98,3.65 6.88,3.45 6.78,3.24L6.47,2.61L6.16,1.97C6,1.64 5.84,1.31 5.69,0.97L5.64,0.87C5.52,0.65 5.35,0.46 5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7L2.66,0.89C1.04,3.23 0.15,6.11 0.01,9.55C-0.03,10.3 0.06,11.28 0.25,12.42L0.32,12.81C0.33,12.87 0.35,12.94 0.36,13L0.44,13.4C0.5,13.67 0.56,13.95 0.63,14.23L0.73,14.66C0.81,14.94 0.89,15.23 0.97,15.53L1.1,15.98C1.71,17.99 2.57,20.16 3.68,22.18L3.82,22.43C3.89,22.56 3.97,22.69 4.05,22.82L4.22,23.09C4.28,23.18 4.34,23.28 4.4,23.37L4.59,23.65C4.65,23.75 4.72,23.85 4.79,23.95L5,24.25L5.23,24.56L5.46,24.87L5.71,25.19L5.96,25.53L6.23,25.86L6.51,26.21C6.56,26.27 6.61,26.33 6.65,26.39L6.95,26.75L7.26,27.11L7.57,27.48L7.9,27.87Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 5.100124462870113)  rotate(0 8.90263690113304 16.52008303654909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 2",
    fillRule: "evenodd",
    fill: "url(#linear_8)",
    transform: "translate(2.0358118368164533 -3.655208082621197)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,12.07C20.77,2.75 11.85,-2.22 5.61,0.96C-0.64,4.14 -1.85,14.28 2.9,23.59C7.65,32.91 16.56,37.88 22.8,34.7C29.05,31.52 30.26,21.39 25.52,12.07Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(8.030155194685197 25.764627009776337)  rotate(-56 17.166630148165577 18.835669996500766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-19",
    fillRule: "evenodd",
    fill: "url(#linear_9)",
    transform: "translate(16.52798649406508 -2.1316282072803006e-14)  rotate(0 8.90263690113304 16.52008303654909)",
    opacity: 1,
    d: "M5.69,0.97L5.64,0.87C5.52,0.65 5.35,0.46 5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7L2.66,0.89C1.04,3.23 0.15,6.11 0.01,9.55C-0.03,10.3 0.06,11.28 0.25,12.42L0.32,12.81C0.33,12.87 0.35,12.94 0.36,13L0.44,13.4C0.5,13.67 0.56,13.95 0.63,14.23L0.73,14.66C0.81,14.94 0.89,15.23 0.97,15.53L1.1,15.98C1.71,17.99 2.57,20.16 3.68,22.18L3.82,22.43C3.89,22.56 3.97,22.69 4.05,22.82L4.22,23.09C4.28,23.18 4.34,23.28 4.4,23.37L4.59,23.65C4.65,23.75 4.72,23.85 4.79,23.95L5,24.25L5.23,24.56L5.46,24.87L5.71,25.19L5.96,25.53L6.23,25.86L6.51,26.21C6.56,26.27 6.61,26.33 6.65,26.39L6.95,26.75L7.26,27.11L7.57,27.48L7.9,27.87L8.24,28.26L8.59,28.65L8.95,29.06L9.33,29.47L9.71,29.89L10.11,30.31L10.51,30.75L10.93,31.19L11.57,31.87L12.25,32.57L12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C10.79,10.33 10,9.11 9.17,7.71L8.88,7.2L8.59,6.68C8.49,6.51 8.39,6.33 8.29,6.15L7.99,5.6C7.79,5.23 7.59,4.84 7.39,4.45L7.09,3.85C6.98,3.65 6.88,3.45 6.78,3.24L6.47,2.61L6.16,1.97C6,1.64 5.84,1.31 5.69,0.97Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 4.631173919903375)  rotate(0 8.90263690113304 16.52008303654909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 3",
    fillRule: "evenodd",
    fill: "url(#linear_10)",
    transform: "translate(2.0358118368164515 -4.747881768474219)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,12.07C20.77,2.75 11.85,-2.22 5.61,0.96C-0.64,4.14 -1.85,14.28 2.9,23.59C7.65,32.91 16.56,37.88 22.8,34.7C29.05,31.52 30.26,21.39 25.52,12.07Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(10.247476314203826 12.456561030408992)  rotate(-30.999999999999993 12.77216995612687 17.65528021787795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    fillRule: "evenodd",
    fill: "url(#linear_11)",
    transform: "translate(7.739066109963456 -1.0658141036401503e-14)  rotate(0 8.90263690114514 16.52008296527144)",
    opacity: 1,
    d: "M5.14,0.32C4.39,-0.23 3.34,-0.05 2.79,0.7C1.08,3.07 0.16,6.01 0.01,9.55C-0.1,12.13 1.14,17.54 3.68,22.18C5.03,24.65 8.04,28.27 12.71,33.04L17.81,18.41C15.75,16.52 13.67,14.17 11.56,11.35C9.75,8.94 7.79,5.48 5.69,0.97C5.57,0.71 5.38,0.48 5.14,0.32Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 2.27039450521303)  rotate(0 8.90263690114514 16.52008296527144)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 4",
    fillRule: "evenodd",
    fill: "url(#linear_12)",
    transform: "translate(2.0358118368406792 -4.747881911029449)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,12.07C20.77,2.75 11.85,-2.22 5.61,0.96C-0.64,4.14 -1.85,14.28 2.9,23.59C7.65,32.91 16.56,37.88 22.8,34.7C29.05,31.52 30.26,21.39 25.52,12.07Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(22.147854099233736 0.2965048787398814)  rotate(-2 8.773661329864003 16.49417428937431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-27",
    fillRule: "evenodd",
    fill: "url(#linear_13)",
    transform: "translate(0.1945750550101657 5.329070518200751e-15)  rotate(0 8.676373802358922 16.485915242855622)",
    opacity: 1,
    d: "M5.27,0.97L5.22,0.88C5.08,0.63 4.89,0.42 4.65,0.27C3.87,-0.23 2.83,-0.01 2.32,0.77L2.2,0.96C0.88,3.1 0.15,5.8 0.01,9.07C-0.04,10.12 0.14,11.62 0.53,13.34L0.63,13.76C0.7,14.04 0.77,14.33 0.85,14.62L0.97,15.06C1.59,17.2 2.49,19.54 3.68,21.71C3.7,21.75 3.73,21.79 3.75,21.84L3.9,22.1C3.92,22.14 3.95,22.18 3.98,22.23L4.14,22.5L4.31,22.78C4.34,22.83 4.37,22.88 4.4,22.93L4.59,23.22C4.62,23.27 4.66,23.32 4.69,23.37L4.9,23.68L5.11,24L5.34,24.33C5.38,24.38 5.41,24.44 5.45,24.49L5.69,24.83L5.95,25.18L6.21,25.54L6.48,25.91L6.76,26.28L7.06,26.66L7.36,27.06L7.84,27.66L8.33,28.29L8.86,28.93L9.22,29.38L9.78,30.06L10.16,30.52L10.56,30.99L11.18,31.72L11.6,32.21L12.25,32.97L17.35,18.34C15.3,16.45 13.22,14.1 11.11,11.28C10.75,10.8 10.38,10.28 10.01,9.72L9.73,9.29C9.64,9.14 9.54,8.99 9.45,8.84L9.16,8.38C8.93,7.99 8.69,7.58 8.44,7.16L8.15,6.64C7.81,6.03 7.46,5.39 7.11,4.72L6.81,4.13L6.5,3.53L6.2,2.91C6.1,2.7 5.99,2.49 5.89,2.28L5.58,1.63C5.47,1.41 5.37,1.19 5.27,0.97Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0.016518093037356962)  rotate(0 8.676373802358922 16.485915242855622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_5"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 5",
    fillRule: "evenodd",
    fill: "url(#linear_14)",
    transform: "translate(1.583285641426702 -4.816217355861088)  rotate(0 14.206495648806444 17.831327085747848)",
    opacity: 1,
    d: "M25.52,12.07C20.77,2.75 11.85,-2.22 5.61,0.96C-0.64,4.14 -1.85,14.28 2.9,23.59C7.65,32.91 16.56,37.88 22.8,34.7C29.05,31.52 30.26,21.39 25.52,12.07Z "
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(45.04045635223401 5.891179613854091)  rotate(0 29.44977182388299 29.70141821458385)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(16.908704663520716 20.866703358546992)  rotate(80 9.264477041954144 24.97239444814332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-31",
    fillRule: "evenodd",
    fill: "url(#linear_15)",
    transform: "translate(1.4210854715202004e-14 16.904622823188475)  rotate(0 8.90263690113304 16.52008303654909)",
    opacity: 1,
    d: "M11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.43,0.48 12.24,0.71 12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0.723680281642217 0)  rotate(0 8.90263690113304 16.52008303654909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_6"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 6",
    fillRule: "evenodd",
    fill: "url(#linear_16)",
    transform: "translate(-12.643529334321695 -3.609252451660737)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,23.59C30.26,14.28 29.05,4.14 22.8,0.96C16.56,-2.22 7.65,2.75 2.9,12.07C-1.85,21.39 -0.64,31.52 5.61,34.7C11.85,37.88 20.77,32.91 25.52,23.59Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(20.41777345190517 10.210741415633699)  rotate(56 11.048308525735463 25.668391137097107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-34",
    fillRule: "evenodd",
    fill: "url(#linear_17)",
    transform: "translate(-1.4210854715202004e-14 18.296616201096025)  rotate(0 8.90263690113304 16.52008303654909)",
    opacity: 1,
    d: "M17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.46,0.46 12.29,0.65 12.17,0.87L12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(4.291343249204843 7.105427357601002e-15)  rotate(0 8.90263690113304 16.52008303654909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 7",
    fillRule: "evenodd",
    fill: "url(#linear_18)",
    transform: "translate(-12.643529334321798 -4.747881768474144)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,23.59C30.26,14.28 29.05,4.14 22.8,0.96C16.56,-2.22 7.65,2.75 2.9,12.07C-1.85,21.39 -0.64,31.52 5.61,34.7C11.85,37.88 20.77,32.91 25.52,23.59Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(18.33161478380353 2.5526369348082643)  rotate(30.999999999999993 10.987766421730973 21.79519562087145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-37",
    fillRule: "evenodd",
    fill: "url(#linear_19)",
    transform: "translate(7.105427357601002e-15 10.550225168644731)  rotate(0 8.90263690113304 16.52008303654909)",
    opacity: 1,
    d: "M11.57,25.86L11.84,25.53L12.1,25.19L12.34,24.87L12.58,24.56L12.8,24.25L13.01,23.95C13.08,23.85 13.15,23.75 13.22,23.65L13.41,23.37C13.47,23.28 13.53,23.18 13.59,23.09L13.75,22.82C13.83,22.69 13.91,22.56 13.98,22.43L14.13,22.18C15.23,20.16 16.09,17.99 16.7,15.98L16.83,15.53C16.92,15.23 17,14.94 17.07,14.66L17.18,14.23C17.25,13.95 17.31,13.67 17.37,13.4L17.45,13C17.46,12.94 17.47,12.87 17.48,12.81L17.55,12.42C17.75,11.28 17.83,10.3 17.8,9.55C17.65,6.11 16.77,3.23 15.15,0.89L15.01,0.7C14.47,-0.05 13.42,-0.23 12.66,0.32C12.46,0.46 12.29,0.65 12.17,0.87L12.12,0.97C11.96,1.31 11.8,1.64 11.65,1.97L11.34,2.61L11.03,3.24C10.92,3.45 10.82,3.65 10.72,3.85L10.41,4.45C10.21,4.84 10.01,5.23 9.81,5.6L9.51,6.15C9.41,6.33 9.32,6.51 9.22,6.68L8.92,7.2L8.63,7.71C7.81,9.11 7.01,10.33 6.24,11.35C4.13,14.17 2.05,16.52 0,18.41L5.1,33.04L5.56,32.57L6.23,31.87L6.88,31.19L7.29,30.75L7.7,30.31L8.09,29.89L8.48,29.47L8.85,29.06L9.21,28.65L9.56,28.26L9.9,27.87L10.23,27.48L10.55,27.11L10.86,26.75L11.15,26.39C11.2,26.33 11.25,26.27 11.3,26.21L11.57,25.86Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(4.170259041195884 -1.2434497875801753e-14)  rotate(0 8.90263690113304 16.52008303654909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_8"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 8",
    fillRule: "evenodd",
    fill: "url(#linear_20)",
    transform: "translate(-12.643529334321684 -4.747881768474164)  rotate(0 14.206495649885673 17.831327085747848)",
    opacity: 1,
    d: "M25.52,23.59C30.26,14.28 29.05,4.14 22.8,0.96C16.56,-2.22 7.65,2.75 2.9,12.07C-1.85,21.39 -0.64,31.52 5.61,34.7C11.85,37.88 20.77,32.91 25.52,23.59Z "
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(10.867796428701702 0.4827852308024969)  rotate(2 8.76948672257236 16.71592567899082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-39",
    fillRule: "evenodd",
    fill: "url(#linear_21)",
    transform: "translate(0 0.4600208722704071)  rotate(0 8.676373802358922 16.485915242855622)",
    opacity: 1,
    d: "M10.3,26.66L10.59,26.28L10.87,25.91L11.14,25.54L11.41,25.18L11.66,24.83L11.9,24.49C11.94,24.44 11.98,24.38 12.02,24.33L12.24,24L12.46,23.68L12.66,23.37C12.7,23.32 12.73,23.27 12.76,23.22L12.95,22.93C12.98,22.88 13.01,22.83 13.04,22.78L13.21,22.5L13.38,22.23C13.4,22.18 13.43,22.14 13.46,22.1L13.6,21.84C13.63,21.79 13.65,21.75 13.67,21.71C14.86,19.54 15.77,17.2 16.38,15.06L16.5,14.62C16.58,14.33 16.66,14.04 16.72,13.76L16.82,13.34C17.21,11.62 17.39,10.12 17.35,9.07C17.21,5.8 16.48,3.1 15.15,0.96L15.03,0.77C14.52,-0.01 13.48,-0.23 12.7,0.27C12.43,0.44 12.22,0.68 12.09,0.97C11.98,1.19 11.88,1.41 11.77,1.63L11.46,2.28C11.36,2.49 11.26,2.7 11.15,2.91L10.85,3.53L10.54,4.13L10.24,4.72C9.89,5.39 9.54,6.03 9.2,6.64L8.91,7.16C8.67,7.58 8.43,7.99 8.19,8.38L7.9,8.84C7.81,8.99 7.72,9.14 7.62,9.29L7.34,9.72C6.97,10.28 6.6,10.8 6.24,11.28C4.13,14.1 2.05,16.45 0,18.34L5.1,32.97L5.75,32.21L6.18,31.72L6.79,30.99L7.19,30.52L7.58,30.06L8.14,29.38L8.5,28.93L9.02,28.29L9.52,27.66L9.99,27.06L10.3,26.66Z "
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0.18622584042688572 -8.881784197001252e-15)  rotate(0 8.676373802358922 16.485915242855622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9",
    fillRule: "evenodd",
    fill: "url(#linear_22)",
    transform: "translate(-12.643529334321563 -4.816217355861106)  rotate(0 14.206495648806444 17.831327085747848)",
    opacity: 1,
    d: "M25.52,23.59C30.26,14.28 29.05,4.14 22.8,0.96C16.56,-2.22 7.65,2.75 2.9,12.07C-1.85,21.39 -0.64,31.52 5.61,34.7C11.85,37.88 20.77,32.91 25.52,23.59Z "
  })))))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(24.06985154943063 19.63506913670792)  rotate(0 23.156727348468372 23.070204558932456)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "bg1",
    fillRule: "evenodd",
    fill: "url(#linear_23)",
    transform: "translate(0 1.7763568394002505e-15)  rotate(0 23.156727348468372 23.070204558932456)",
    opacity: 1,
    d: "M23.16,0C10.37,0 0,10.33 0,23.07C0,35.81 10.37,46.14 23.16,46.14C35.95,46.14 46.31,35.81 46.31,23.07C46.31,10.33 35.95,0 23.16,0Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(2.5261884380147315 2.9362078529550484)  rotate(0 20.420023207285745 20.34372583833135)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path-43",
    fillRule: "evenodd",
    fill: "url(#linear_24)",
    transform: "translate(0 0)  rotate(0 20.420023207285745 20.34372583833135)",
    opacity: 1,
    d: "M20.42,0C9.14,0 0,9.11 0,20.34C0,31.58 9.14,40.69 20.42,40.69C31.7,40.69 40.84,31.58 40.84,20.34C40.84,9.11 31.7,0 20.42,0Z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-43",
    filter: "url(#filter_124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-43",
    fillRule: "evenodd",
    style: {
      fill: "#000000"
    },
    transform: "translate(0 0)  rotate(0 20.420023207285745 20.34372583833135)",
    opacity: 0,
    d: "M20.42,0C9.14,0 0,9.11 0,20.34C0,31.58 9.14,40.69 20.42,40.69C31.7,40.69 40.84,31.58 40.84,20.34C40.84,9.11 31.7,0 20.42,0Z "
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(5.473408282365252 5.452957441202228)  rotate(0 17.472803362935228 17.40751798537631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-46",
    filter: "url(#filter_128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-46",
    fillRule: "evenodd",
    style: {
      fill: "#000000"
    },
    transform: "translate(-1.7763568394002505e-14 0)  rotate(0 17.472803362935228 17.40751798537631)",
    opacity: 0,
    d: "M17.47,0C7.82,0 0,7.79 0,17.41C0,27.02 7.82,34.82 17.47,34.82C27.12,34.82 34.95,27.02 34.95,17.41C34.95,7.79 27.12,0 17.47,0Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path-46",
    fillRule: "evenodd",
    fill: "url(#linear_25)",
    transform: "translate(-1.7763568394002505e-14 0)  rotate(0 17.472803362935228 17.40751798537631)",
    opacity: 1,
    d: "M17.47,0C7.82,0 0,7.79 0,17.41C0,27.02 7.82,34.82 17.47,34.82C27.12,34.82 34.95,27.02 34.95,17.41C34.95,7.79 27.12,0 17.47,0Z "
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    style: {
      fill: "#FFFFFF"
    },
    transform: "translate(30.595838389738514 12.553084912793487)  rotate(0 3.999798360189992 3.984853514724696)",
    opacity: 0.100000001,
    d: "M4,0C1.79,0 0,1.78 0,3.98C0,6.19 1.79,7.97 4,7.97C6.21,7.97 8,6.19 8,3.98C8,1.78 6.21,0 4,0Z "
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u692D\\u5706\\u5F62",
    fillRule: "evenodd",
    fill: "url(#linear_26)",
    transform: "translate(36.27976237527166 12.133626648085599)  rotate(0 2.736704141182625 2.7264787206011087)",
    opacity: 1,
    d: "M2.74,0C1.23,0 0,1.22 0,2.73C0,4.23 1.23,5.45 2.74,5.45C4.25,5.45 5.47,4.23 5.47,2.73C5.47,1.22 4.25,0 2.74,0Z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(50.15084942347226 7.1774776717805)  rotate(-12 4.63013940290548 4.615632307406146)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path-55",
    fillRule: "evenodd",
    fill: "url(#linear_27)",
    transform: "translate(0 -1.7763568394002505e-15)  rotate(0 4.63013940290548 4.615632307406146)",
    opacity: 1,
    d: "M1.9,4.7L0.02,8.94C-0.01,8.99 -0.01,9.05 0.02,9.11C0.07,9.21 0.19,9.26 0.3,9.21L4.55,7.31C4.61,7.28 4.67,7.28 4.72,7.31L8.95,9.2C9,9.22 9.07,9.22 9.13,9.2C9.23,9.14 9.27,9.02 9.22,8.91L7.22,4.85C7.19,4.79 7.19,4.73 7.21,4.67L9.24,0.3C9.27,0.25 9.27,0.18 9.24,0.13C9.19,0.02 9.07,-0.02 8.96,0.02L4.72,1.95C4.67,1.98 4.61,1.98 4.55,1.95L0.3,0.02C0.24,-0.01 0.18,-0.01 0.13,0.02C0.02,0.06 -0.03,0.19 0.02,0.29L1.9,4.53C1.92,4.58 1.92,4.64 1.9,4.7Z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-55",
    filter: "url(#filter_140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-55",
    fillRule: "evenodd",
    style: {
      fill: "#000000"
    },
    transform: "translate(0 -1.7763568394002505e-15)  rotate(0 4.63013940290548 4.615632307406146)",
    opacity: 0,
    d: "M1.9,4.7L0.02,8.94C-0.01,8.99 -0.01,9.05 0.02,9.11C0.07,9.21 0.19,9.26 0.3,9.21L4.55,7.31C4.61,7.28 4.67,7.28 4.72,7.31L8.95,9.2C9,9.22 9.07,9.22 9.13,9.2C9.23,9.14 9.27,9.02 9.22,8.91L7.22,4.85C7.19,4.79 7.19,4.73 7.21,4.67L9.24,0.3C9.27,0.25 9.27,0.18 9.24,0.13C9.19,0.02 9.07,-0.02 8.96,0.02L4.72,1.95C4.67,1.98 4.61,1.98 4.55,1.95L0.3,0.02C0.24,-0.01 0.18,-0.01 0.13,0.02C0.02,0.06 -0.03,0.19 0.02,0.29L1.9,4.53C1.92,4.58 1.92,4.64 1.9,4.7Z "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.cfbfdedf57ac29d74ff7a57841225674.svg";
export { ForwardRef as ReactComponent };